var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoToome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 745",
    width: 753,
    height: 274,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1568,79)",
    d: "m0 0h48l15 1 10 4 7 8 3 7 3 30 6 69 15 153 6 71 4 52 2 23v12l-4 10-4 5-8 3h-76l-9-4-6-7-3-8-5-62-4-57-5-67-5-62v-8h-2l-2 5-18 38-39 84-12 25-10 18-6 11-7 8-8 5-13 4-17 1-12-2-12-5-9-8-11-18-9-17-12-26-12-27-7-15-16-35-16-36-8-16-2-1v12l-7 70-11 104-8 70-3 14-4 6-5 4-6 2h-78l-7-4-4-5-1-2v-19l7-64 4-38 9-72 9-62 7-53 7-50 5-36 2-16 4-12 6-7 9-5 4-1h73l9 3 9 8 7 11 13 28 20 41 13 27 11 23 17 35 13 28 9 19 3-4 8-16 17-35 8-16 12-25 21-42 11-23 15-31 8-16 7-8 10-6 6-2z",
    fill: "#D75C10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,89)",
    d: "m0 0 4 2 10 14 26 46 14 24 12 21 9 17 2 6v7l-4 5-2 1-23 2-20 4-49 14-12 3-7 1h-11l-6-2 13 12 5 4 11-2 17-5 5 1 6 9 6 16 5 21 3 24v23l-4 27-6 23-8 21-9 17-10 15-7 9-11 12-8 8-13 10-18 11-19 9-20 7-27 6-25 2h-13l-26-2-18-4-20-7-29-14-16-11-14-12-14-14-13-17-9-15-8-16-7-20-6-26-2-16v-23l3-24 5-21 8-21 8-16 10-14 12-13 13-12 3-1 2 4-2 16 7 11 4-1 19-12 19-10 16-6 19-5 27-4 12-1h18l27 4 19 5 14 5 17 8 20 12 4 5 8-15 7-11-1-3-16-9-15-7-24-8-21-5-24-3h-38l-24 3-21 5-26 9-23 12-7 5h-3l1-6 11-13 8-8 11-9 19-14 15-9 16-8 20-9 28-9 27-6 20-3h44l19 3 21 6 16 6 7-30 4-18zm-61 160m2 3m-128 5-15 4-17 8-10 8-7 7-7 10-7 15-4 13-3 21v18l2 14 6 18 6 11 9 11 10 10 13 8 12 5 8 2 11 1h11l14-2 16-6 11-6 14-12 10-15 6-15 3-12 1-8v-27l-3-17-6-18-8-14-9-11-13-10-17-8-14-3z",
    fill: "#D75C10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(45,25)",
    d: "m0 0h353l10 3 9 8 4 9v70l-4 8-4 5-8 5-11 2h-111v372l-5 10-5 4-9 4-12 2-65-1-10-4-7-6-4-8-1-5-1-72v-258l1-38h-111l-14-1-9-5-6-7-3-6v-73l6-9 6-5z",
    fill: "#D75C10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,162)",
    d: "m0 0h21l25 2 24 5 22 8 21 11 12 8 13 10 16 15 9 11 9 12 8 13 8 16 7 18 5 20 3 21v28l-3 22-4 19-7 20-10 21-10 15-7 9-11 12-11 11-17 13-21 12-19 8-20 6-18 4-8 1h-39l-15-2-24-6-20-7-18-8-17-10-13-10-13-12-9-9-13-18-8-14-7-14-8-24-3-13-3-22v-33l4-24 6-21 8-19 8-15 11-16 13-16 13-13 17-13 18-11 16-8 21-7 17-4zm7 94-17 4-9 4-10 6-10 8-7 8-7 10-7 15-5 18-2 15v17l4 20 5 14 7 12 11 12 8 7 14 8 15 5 5 1h26l15-4 16-8 10-7 11-11 8-13 6-14 3-14v-34l-2-13-5-16-7-14-8-10-8-8-13-9-14-6-14-3z",
    fill: "#D75C10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1854,163)",
    d: "m0 0h33l20 3 20 6 12 5 20 12 11 9 12 11 10 12 10 15 8 16 8 20 5 17 4 21 2 19v18l-3 16-5 8-5 4-5 2-6 1h-202l7 23 7 12 9 10 8 7 16 8 11 4 16 3h30l20-4 16-5 12-5 23-11 5-2 10 7 6 7 11 16 6 12 2 6v11l-3 6-6 7-13 10-19 11-18 8-25 8-30 5-14 1h-15l-27-3-21-5-21-8-16-8-16-10-10-8-10-9-9-9-11-14-9-14-8-16-6-15-4-14-4-22-1-12v-39l2-18 6-24 8-21 8-16 9-15 13-16 15-15 18-13 17-10 20-8 18-5zm19 81-16 2-15 5-10 7-9 8-7 10-8 17-3 11v3l63 1h68l-1-8-5-17-7-13-8-10-11-8-12-5-16-3z",
    fill: "#D65B0F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,89)",
    d: "m0 0 4 2 10 14 26 46 14 24 12 21 9 17 2 6v7l-4 5-2 1-23 2-20 4-49 14-12 3-7 1h-11l-8-4-2-4 1-6 6-11 7-11-1-3-16-9-15-7-24-8-21-5-24-3h-38l-24 3-21 5-26 9-23 12-7 5h-3l1-6 11-13 8-8 11-9 19-14 15-9 16-8 20-9 28-9 27-6 20-3h44l19 3 21 6 16 6 7-30 4-18z",
    fill: "#257569"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,623)",
    d: "m0 0 16 2 8 4 5 5 4 5v2l4-4 6-7 10-5 5-1h17l11 4 8 6 6 9 3 11v68h-23l-2-65-4-8-5-4-8-2-10 1-6 4-4 7-1 5-1 62h-23l-1-57-2-12-4-6-6-3-4-1h-7l-8 3-5 6-3 9-1 61h-23l-1-2v-94l3-1 19 1 1 1v11h2l2-4 5-5 7-4z",
    fill: "#247468"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1650,587)",
    d: "m0 0h23l1 1v133l-1 1h-16l-3-3-2-9-8 8-10 5-6 1h-18l-10-3-10-6-7-8-5-10-3-11-1-7v-10l3-15 7-14 7-7 8-5 9-3 6-1h12l12 3 8 6 5 4-1-3zm-32 56-10 5-6 9-3 10v13l4 13 6 7 7 4 4 1h12l10-5 6-8 3-10v-16l-3-10-6-8-7-4-3-1z",
    fill: "#247468"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,624)",
    d: "m0 0h23l13 4 9 6 6 9 3 9 1 46 3 7 6 2-1 14-1 1-14 1-8-2-5-5-2-6-11 9-9 4-16 2-12-2-10-6-6-9-2-5v-14l4-9 7-8 12-6 14-3 26-1-1-10-4-6-5-3-13-1-10 3-8 6-2 3-10-3-9-3 2-6 6-8 10-6 9-3zm14 54-13 2-6 4-4 6-1 6 3 7 4 3 3 1h11l9-3 8-9 3-9 1-7-1-1z",
    fill: "#257569"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,624)",
    d: "m0 0h23l12 3 10 6 5 4 7 10 4 11 1 5v21l-3 12-7 12-8 8-10 5-12 3-15 1-13-2-12-5-10-9-6-9-5-14v-25l4-12 7-11 8-7 11-5zm5 18-8 3-7 7-4 9-1 6v12l3 12 4 7 6 5 7 3h14l8-4 7-7 3-10v-22l-4-11-9-8-7-2z",
    fill: "#257569"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,624)",
    d: "m0 0h23l11 3 9 5 9 8 6 10 3 10 1 7v13l-3 14-6 12-8 9-14 7-9 2-17 1-15-3-13-7-8-9-5-10-3-11v-21l3-12 6-11 5-6 11-7 9-3zm5 18-8 3-6 5-5 11-1 5v17l4 11 7 8 9 4h13l10-5 6-7 2-5 1-6v-20l-3-9-7-8-6-3-5-1z",
    fill: "#257569"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1767,623)",
    d: "m0 0 20 2 12 5 10 9 6 9 4 11 1 6v16l-3 15-6 11-8 8-8 5-9 3-6 1h-23l-12-4-10-6-8-9-5-10-3-12v-20l4-13 5-9 6-7 12-7 11-3zm-4 19-8 3-5 4-5 9-2 10v10l2 11 5 9 6 5 7 3h13l12-6 5-7 3-13v-13l-2-9-5-8-7-6-8-2z",
    fill: "#257569"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1108,624)",
    d: "m0 0h17l13 4 11 8 8 11 4 11 2 11v11l-5 1h-66l3 10 5 9 9 5h19l8-5 4-5 20 2 1 2-6 10-7 7-12 6-9 2-14 1-12-2-10-4-9-7-7-9-5-11-2-11v-12l3-14 4-9 4-6 8-8 12-6zm4 17-10 4-6 8-4 11 1 2h46l1-4-5-12-4-5-6-3-5-1z",
    fill: "#257569"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,624)",
    d: "m0 0h20l10 4 6 4 7 9 4 11 1 6v63l-1 1h-22l-1-1-1-61-4-11-5-4-8-2-11 1-7 4-4 6-2 7-1 61h-23l-1-6v-90l1-1 20 1v12l8-7 8-5z",
    fill: "#257569"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1343,624)",
    d: "m0 0h23l10 3 9 5 8 7 6 10 2 5-3 1-20 1-6-7v-2l-5-2-7-2h-12l-9 4-5 6-3 8-1 7v12l3 12 6 8 7 4 3 1h13l8-4 5-6 3-6h24l-1 4-4 9-4 6-6 7-6 4-12 4-7 1h-19l-13-4-8-5-7-7-5-8-4-12-1-5v-17l3-14 6-11 5-6 9-6 10-4z",
    fill: "#257569"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(45,25)",
    d: "m0 0h353l10 3 9 8 4 9v70l-4 8-4 5-8 5-11 2h-111v372l-5 10-5 4-9 4-12 2-65-1-10-4-7-6-4-8-1-5v-203l1-169h2v329l1 47 6 9 6 4 13 2h53l14-1 10-3 5-4 3-8 1-31v-312l1-31 3-1 105-1 13-1 7-3 5-4 2-5 1-12v-51l-1-12-5-8-4-3-4-1-141-1h-208l-15 2-6 3-4 4-3 8-1 15v51l3 9 5 5 4 3 4 1 123 1v1l-10 1h-116l-8-5-5-6-3-6v-73l6-9 6-5z",
    fill: "#B33D0B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,600)",
    d: "m0 0h24v26h26v16l-1 1h-25l1 48 2 9 3 3 8 2 9 1 1 1-1 11-2 5h-18l-11-2-6-3-7-8-3-8-1-12v-47h-11l-1-1-1-16h13v-12z",
    fill: "#257569"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1568,79)",
    d: "m0 0h48l15 1 10 4 7 8 3 7 3 30 6 69 15 153 6 71 4 52 2 23v12l-4 10-4 5-8 3h-76l-9-4-6-7-3-8-5-62-4-57-5-67-4-50v-19h2l4 36 2 31 4 51 4 55 3 39 3 40 2 9 2 5 5 2 2 1h81l6-1 2-6 1-2v-28l-4-43-4-54-3-35-7-66-3-34-11-118-2-28-2-12-6-8-7-3h-71l-13 3-8 6-6 9-14 29-10 22-9 17-8 16-12 25-8 16-13 27-11 23-13 26h-3l1-5 8-16 16-33 8-16 12-25 21-42 11-23 15-31 8-16 7-8 10-6 6-2z",
    fill: "#B5400C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,162)",
    d: "m0 0h21l25 2 24 5 22 8 21 11 12 8 13 10 16 15 9 11 9 12 8 13 8 16 7 18 5 20 3 21v28l-3 22-4 19-7 20-10 21-10 15-7 9-11 12-11 11-17 13-21 12-19 8-20 6-18 4-8 1h-39l-15-2-24-6-20-7-18-8-17-10-13-10-13-12-9-9-13-18-8-14-7-14-8-24-3-13-3-22v-33l4-24 6-21 8-19 8-15 11-16 13-16 13-13 17-13 18-11 16-8 21-7 17-4zm4 3-25 2-30 8-20 9-17 10-10 7-10 9-8 7-12 13-13 18-9 16-8 19-6 19-5 26-1 13v19l3 25 5 21 7 19 10 19 9 14 11 13 13 13 14 11 15 9 19 9 30 10 23 5 13 2h33l21-4 28-8 21-9 15-9 14-10 12-11 11-12 9-12 9-13 8-15 6-14 6-21 4-22 1-12v-25l-3-20-4-16-4-13-8-19-9-16-9-13-9-10-7-8-9-9-13-10-9-6-14-8-15-7-18-6-18-4-24-3z",
    fill: "#B43E0C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1854,163)",
    d: "m0 0h33l20 3 20 6 12 5 20 12 11 9 12 11 10 12 10 15 8 16 8 20 5 17 4 21 2 19v18l-2 12-3 3v-41l-3-21-5-21-9-24-8-17-10-16-7-7-7-8-12-11-20-13-11-5-21-7-16-3-13-1h-23l-24 4-18 5-14 5-16 8-11 8-10 8-10 9-8 8-10 13-11 19-9 21-7 23-3 13-1 11v44l2 21 4 21 5 15 10 20 11 16 10 13 13 13 17 13 16 9 18 8 22 7 20 4 7 1h42l20-3 23-6 20-7 17-8 16-11 10-9 5-7-1-8-4-13-8-14-8-10-6-8 4 1 7 8 11 16 6 12 2 6v11l-3 6-6 7-13 10-19 11-18 8-25 8-30 5-14 1h-15l-27-3-21-5-21-8-16-8-16-10-10-8-10-9-9-9-11-14-9-14-8-16-6-15-4-14-4-22-1-12v-39l2-18 6-24 8-21 8-16 9-15 13-16 15-15 18-13 17-10 20-8 18-5z",
    fill: "#B33D0B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,89)",
    d: "m0 0 4 2 10 14 26 46 14 24 12 21 9 17 2 6v7l-4 5-2 1-23 2-20 4-49 14-12 3-7 1h-11l-1-3 18-3 69-18 25-4 13-2v-6l-9-19-10-18-14-24-10-17-12-22-13-21-4-4-7 31-4 13-3 4-9-2-21-7-21-4-10-1h-28l-25 2-20 4-22 6-23 8-16 7-25 13-17 13-8 6-4 4h-2v2l-3 3-1 2h-2l-1 3-3 3 25-11 24-7 17-4 25-3h31l24 3 19 4 24 7 25 11 13 8 3 3v6l-11 18-4 7h-1l1-7 7-12 5-8-1-3-16-9-15-7-24-8-21-5-24-3h-38l-24 3-21 5-26 9-23 12-7 5h-3l1-6 11-13 8-8 11-9 19-14 15-9 16-8 20-9 28-9 27-6 20-3h44l19 3 21 6 16 6 7-30 4-18z",
    fill: "#0D5248"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,624)",
    d: "m0 0h13l2 1-1 19-1 1-15 1-9 3-7 6-4 9-1 9-1 49h-24l-1-96 3-1 19 1 1 15 5-5 8-7 8-4z",
    fill: "#257569"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,81)",
    d: "m0 0h73l9 3 9 8 7 11 13 28 20 41 13 27 11 23 17 35 13 28 6 12v6h-2l-7-16-8-16-15-31-9-20-10-19-11-23-13-28-16-33-9-19-9-10-3-3h-79l-9 3-5 5-3 8-6 39-10 73-6 47-7 49-6 44-8 65-6 57-3 29v12l1 3 7 3 11 1h74l-1 2-6 2h-78l-7-4-4-5-1-2v-19l7-64 4-38 9-72 9-62 7-53 7-50 5-36 2-16 4-12 6-7 9-5z",
    fill: "#B33E0C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(777,215)",
    d: "m0 0 2 1v5l-8 4-13 12-12 15-10 19-10 30-3 15-2 12v37l4 25 6 22 7 17 12 20 8 11 9 11 13 13 11 9 17 11 16 8 20 8 23 6 21 3h33l27-4 28-8 18-7 16-9 11-8 11-9 16-16 11-15 9-15 9-19 8-24 5-24 2-20v-18l-5-31-6-19-5-13-1-4-18 5-7 2h-8l-10-7-4-6 6 2 9 8 11-2 17-5 5 1 6 9 6 16 5 21 3 24v23l-4 27-6 23-8 21-9 17-10 15-7 9-11 12-8 8-13 10-18 11-19 9-20 7-27 6-25 2h-13l-26-2-18-4-20-7-29-14-16-11-14-12-14-14-13-17-9-15-8-16-7-20-6-26-2-16v-23l3-24 5-21 8-21 8-16 10-14 12-13 13-12z",
    fill: "#B43E0C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,624)",
    d: "m0 0h17l11 4 8 6 6 9 3 11v68h-23l-2-65-4-8-5-4-8-2-10 1-6 4-4 7-1 5-1 62h-23l-1-57-2-12-4-6-6-3-4-1h-7l-8 3-5 6-3 9-1 61h-23l-1-2v-94l3-1 19 1v10l-2-1-1-4-15-1v89h17v-31l1-34 5-8 6-5 5-2h13l9 4 6 7 2 5v63l16 1v-20l1-42 5-10 8-6 3-1h14l10 5 6 8 1 3 1 41v22h17l-1-45-1-17-2-10-5-9-5-5-9-4-6-1h-10l-11 3-9 6-7 6 1-5 7-8 10-5z",
    fill: "#105A4E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(45,25)",
    d: "m0 0h353l10 3 1 3-6-1-141-1h-208l-15 2-6 3-4 4-3 8-1 15v51l3 9 5 5 4 3 4 1 123 1v1l-10 1h-116l-8-5-5-6-3-6v-73l6-9 6-5z",
    fill: "#B03B0B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1854,163)",
    d: "m0 0h33l20 3 20 6 12 5 20 12 11 9 12 11 10 12 10 15 8 16 8 20 5 17 4 21 2 19v18l-2 12-3 3v-41l-3-21-5-21-9-24-8-17-10-16-7-7-7-8-12-11-20-13-11-5-21-7-16-3-13-1h-23l-24 4-18 5-14 5-16 8-11 8-10 8-10 9-8 8-10 13-11 19-9 21-7 23-2 9-3 3-2 28v18l1 18v11h-1l-2-19v-39l2-18 6-24 8-21 8-16 9-15 13-16 15-15 18-13 17-10 20-8 18-5z",
    fill: "#B33E0C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,253)",
    d: "m0 0h23l14 3 12 5 11 7 13 12 9 11 9 19 5 21 1 10v22l-1 10-5 16-9 17-6 8-5 5-9 8-9 6-12 6-14 3-8 1h-17l-17-3-11-6-11-7-11-9-7-7-9-14-5-13-5-20v-24l3-17 6-18 8-15 12-14 13-11 16-8zm3 3-17 4-9 4-10 6-10 8-7 8-7 10-7 15-5 18-2 15v17l4 20 5 14 7 12 11 12 8 7 14 8 15 5 5 1h26l15-4 16-8 10-7 11-11 8-13 6-14 3-14v-34l-2-13-5-16-7-14-8-10-8-8-13-9-14-6-14-3z",
    fill: "#B53F0C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,254)",
    d: "m0 0h29l12 3 14 7 11 8 11 11 10 16 7 17 4 15v33l-4 21-6 16-8 12-11 11-10 7-16 8-15 4h-30l-15-5-16-9-15-14-9-11-6-11-5-13-2-8-1-10v-23l3-19 6-17 7-13 11-13 9-8 11-7 11-5zm2 3-15 4-17 8-10 8-7 7-7 10-7 15-4 13-3 21v18l2 14 6 18 6 11 9 11 10 10 13 8 12 5 8 2 11 1h11l14-2 16-6 11-6 14-12 10-15 6-15 3-12 1-8v-27l-3-17-6-18-8-14-9-11-13-10-17-8-14-3z",
    fill: "#B53F0C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,624)",
    d: "m0 0h20l10 4 6 4 7 9 4 11 1 6v63l-1 1h-22l-1-1-1-61-4-11-5-4-8-2-11 1-7 4-4 6-2 7-1 61h-23l-1-6v-90l1-1 20 1v11l-2-3-1-3-14-2 1 84v6l16-1 1-64 4-6 9-7 3-1h15l10 5 6 8 1 3v63l16-1v-58l-2-15-5-8-6-5-7-3-5-1-16 1-12 4-5 3h-2l2-4 9-6z",
    fill: "#155F53"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1343,624)",
    d: "m0 0h23l10 3 9 5 8 7 6 10 2 5-3 1-20 1-6-7v-2l-5-2-7-2h-12l-9 4-5 6-3 8-1 7v12l3 12 6 8 7 4 3 1h13l8-4 5-6 3-6h24l-1 4-4 9-4 6-6 7-6 4-12 4-7 1h-19l-13-4-8-5-7-7-5-8-4-12-1-5v-17l3-14 6-11 5-6 9-6 10-4zm5 3-14 3-12 7-7 9-5 13-2 12v10l4 16 5 9 5 5 7 5 14 4 4 1h11l15-3 10-5 7-6 7-12v-2h-16l-8 10-5 4-12 2-9-1-6-1v-2l-6-5-4-5-4-10-1-7v-10l3-12 6-9 10-6 3-1h16l9 5 3 4h2v2l2 1h14l1-4-6-9h-2l-1-3-12-6-6-2-11-1z",
    fill: "#0F594D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1302,247)",
    d: "m0 0h2l6 10 5 10 11 25 9 20 11 25 9 21 15 31 11 23 11 19 8 9 11 4 11 2h13l12-2 11-4 7-8 9-16 13-26 11-23 16-34 15-33 17-35 5-10 2-1-1 7-16 34-39 84-12 25-10 18-6 11-7 8-8 5-13 4-17 1-12-2-12-5-9-8-11-18-9-17-12-26-12-27-7-15-16-35-16-36-6-12z",
    fill: "#B33E0B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,624)",
    d: "m0 0h23l13 4 9 6 6 9 3 9 1 46 3 7 6 2-1 14-1 1-14 1-8-2-5-5-1-6h2l3 4v2l8 2 12 1-1-8 1-2-5-2-2-5-1-29-2-21-4-11-6-7-12-5-7-1h-13l-12 2-12 5-7 5-2 5 3 2h8l16-8 4-1h11l9 3 6 5 3 7v9l-3 3-4 1-23 2-12 3-10 4-6 4-4 7-1 4v12l3 8 5 5 9 4 5 1h15l11-4 8-6 4-2-1 4-8 7-9 4-16 2-12-2-10-6-6-9-2-5v-14l4-9 7-8 12-6 14-3 26-1-1-10-4-6-5-3-13-1-10 3-8 6-2 3-10-3-9-3 2-6 6-8 10-6 9-3z",
    fill: "#0E594D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1108,624)",
    d: "m0 0h17l13 4 11 8 8 11 4 11 2 11v11l-5 1h-66l3 10 5 9 9 5h19l8-5 4-5 20 2 1 2-6 10-7 7-12 6-9 2-14 1-12-2-10-4-9-7-7-9-5-11-2-11v-12l3-14 4-9 4-6 8-8 12-6zm6 3-12 2-12 5-8 7-5 8-4 11-1 6v19l3 12 7 12 8 6 11 4 10 2h11l11-2 12-5 8-7 2-5-2-1h-13v2l-5 2-7 3-7 1h-11l-10-5-7-8-2-7v-8l1-2 20-1h48v-9l-4-16-6-11-6-7-11-6-11-2z",
    fill: "#0F5A4E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,600)",
    d: "m0 0h24v26h26v16l-1 1h-25l1 48 2 9 3 3 8 2 9 1 1 1-1 11-2 5h-18l-11-2-6-3-7-8-3-8-1-12v-47h-11l-1-1-1-16h12l1 4-8 1v8l10 2 2 5-1 33 1 3 2 23 5 8 10 4 16 1 5-1 2-7-11-2-6-3-4-5-1-3v-56l1-1 24-1v-8l-21-1-4-2-1-11v-14h-16v10l-1 8-3-1 1-6-1-3z",
    fill: "#105B4F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,625)",
    d: "m0 0 21 1v10l-2-1-1-4-15-1v89h17v-31l1-34 5-8 6-5 5-2h13l9 4 6 7 2 5v63l14 1v2h6v1h-23l-1-57-2-12-4-6-6-3-4-1h-7l-8 3-5 6-3 9-1 61h-23l-1-2v-94z",
    fill: "#0D564B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1568,79)",
    d: "m0 0h48l15 1 6 2v2h-75l-13 3-8 6-6 9-14 29-10 22-9 17-8 16-12 25-8 16-13 27-11 23-13 26h-3l1-5 8-16 16-33 8-16 12-25 21-42 11-23 15-31 8-16 7-8 10-6 6-2z",
    fill: "#B43E0C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,624)",
    d: "m0 0h23l12 3 10 6 5 4 7 10 4 11 1 5v21l-3 12-7 12-8 8-10 5-12 3-15 1-13-2-12-5-10-9-6-9-5-14v-25l4-12 7-11 8-7 11-5zm7 3-16 3-14 7-6 8-5 12-2 12v11l2 11 4 10 8 10 9 6 9 3 5 1h20l11-3 11-6 9-10 5-12 2-12v-9l-2-14-6-12-5-6-16-8-11-2z",
    fill: "#0F594D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,89)",
    d: "m0 0 4 2 10 14 26 46 14 24 12 21 9 17 2 6v7l-4 5-2 1-23 2-20 4-49 14-12 3-7 1h-11l-1-3 18-3 69-18 25-4 13-2v-6l-9-19-10-18-14-24-10-17-12-22-13-21-4-4-2 8-2-3-2 3 1-8 3-5z",
    fill: "#10564B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1767,623)",
    d: "m0 0 20 2 12 5 10 9 6 9 4 11 1 6v16l-3 15-6 11-8 8-8 5-9 3-6 1h-23l-12-4-10-6-8-9-5-10-3-12v-20l4-13 5-9 6-7 12-7 11-3zm-3 4-14 3-10 4-9 8-5 8-3 14v17l2 13 4 10 8 8 14 7 9 2h16l15-3 10-5 7-7 7-14 2-8v-14l-2-14-6-12-7-8-8-5-13-4z",
    fill: "#0D5449"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,624)",
    d: "m0 0h13l2 1-1 19-1 1-15 1-9 3-7 6-4 9-1 9-1 49h-24l-1-96 3-1 19 1v15h-2v-11h-16v89l17-1 1-47 2-12 4-8 8-6 13-4 9-1v-6l2-5h-10l-11 4-9 6-4 3 1-5 9-8 8-4z",
    fill: "#0D574B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,624)",
    d: "m0 0h23l11 3 9 5 9 8 6 10 3 10 1 7v13l-3 14-6 12-8 9-14 7-9 2-17 1-15-3-13-7-8-9-5-10-3-11v-21l3-12 6-11 5-6 11-7 9-3zm5 3-16 3-10 6-8 9-4 8-2 10v24l2 9 5 10 9 8 10 5 8 2h19l11-2 10-4 9-7 7-12 3-9v-26l-4-13-7-9-9-7-10-4-5-1z",
    fill: "#0D5449"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,81)",
    d: "m0 0h73l9 3 9 8 7 11 13 28 20 41 13 27 11 23 17 35 13 28 6 12v6h-2l-7-16-8-16-15-31-9-20-10-19-11-23-13-28-16-33-9-19-9-10-3-3h-84l1-3z",
    fill: "#B33E0C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,30)",
    d: "m0 0 4 2 5 6 3 7v70l-4 8-4 5-8 5-11 2h-111v35l-1 53h-1l-1-60 1-31 3-1 105-1 13-1 7-3 5-4 2-5 1-12v-51l-1-12-5-8z",
    fill: "#B9430C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1295,244)",
    d: "m0 0h2v24l-16 154-9 79-3 14-3 5h-2l2-12 4-27 11-101 5-45 8-83z",
    fill: "#B43F0C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1650,587)",
    d: "m0 0h23l1 1v133l-1 1h-16l-3-3v-7l3 1v5l13 1v-128h-16l-1 45-2 1-1-3z",
    fill: "#125D51"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,583)",
    d: "m0 0 8 2 8 7 9 10 4 5v3h-18l-9-11-2-1-2 4-7 8h-17l2-5 13-15 5-5z",
    fill: "#0D5147"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,99)",
    d: "m0 0h1v9l-5 22-3 9-3 4-9-2-21-7-21-4-10-1h-28l-25 2-20 4-22 6-23 8-8 3-3-1 2-3 21-8 23-7 29-6 14-2h44l19 3 21 6 16 6 7-30 3-10z",
    fill: "#0C5146"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,170)",
    d: "m0 0h1v337l-5 10-5 4-4-1 7-6 3-8 1-31v-200z",
    fill: "#AF3A0B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(901,207)",
    d: "m0 0h18l27 4 19 5 14 5 17 8 20 12 2 4-5-2-7-5-16-8-18-8-26-7-17-3h-34l-21 2-30 7-12 4-13 6-16 9-12 7v-3l15-10 21-11 16-6 19-5 27-4z",
    fill: "#B33E0C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,639)",
    d: "m0 0h11l10 3 7 6 5 8 2 13v17l-3 9-2 4h-2l-1 3-7 5-11 3h-9l-10-4-9-9-4-8-2-8v-11l2-11 5-10 7-6 6-3zm-1 3-8 3-7 7-4 9-1 6v12l3 12 4 7 6 5 7 3h14l8-4 7-7 3-10v-22l-4-11-9-8-7-2z",
    fill: "#0F5A4E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1614,624)",
    d: "m0 0h12l12 3 8 6 3 3-1 2-9-6-10-3h-18l-12 4-6 4-3 3h-2l-2 4-5 12-2 9v22l3 10 6 11 8 7 7 3 11 2h10l10-2 10-5 8-7 1 3-9 9-10 5-6 1h-18l-10-3-10-6-7-8-5-10-3-11-1-7v-10l3-15 7-14 7-7 8-5 9-3z",
    fill: "#0E5549"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1348,639)",
    d: "m0 0h16l10 6 4 4v2h16l2-3 2 7-20 1-6-7v-2l-5-2-7-2h-12l-9 4-5 6-3 8-1 7v12l3 12 6 8 7 4 3 1h13l8-4 5-6 3-6h24l-1 4-2 3h-2v-3l-16 1-7 9-6 5-12 2-9-1-6-2v-2l-4-2-7-8-4-10-1-7v-10l3-12 6-9 9-6z",
    fill: "#0F5A4E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1800,378)",
    d: "m0 0 2 1v2h2l6 20 7 12 9 10 8 7 16 8 11 4 16 3h30l20-4 16-5 12-5 23-11 5-2 4 4-6 1-16 8-17 8-16 5-16 4-9 1h-30l-20-4-11-4-14-9-13-11-8-11-8-16-3-12z",
    fill: "#B33E0B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2023,364)",
    d: "m0 0 1 3-6 7-7 3h-205l-2-2 1-1 201-1 10-3z",
    fill: "#AB370B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,639)",
    d: "m0 0h14l10 4 5 4 6 10 2 7v22l-3 9-7 9-8 4-10 2-10-1-8-4-7-7-5-10-1-5v-20l3-9 7-9zm1 3-8 3-5 4-5 9-2 10v10l2 11 5 9 6 5 7 3h13l12-6 5-7 3-13v-13l-2-9-5-8-7-6-8-2z",
    fill: "#0E594D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,639)",
    d: "m0 0h9l10 3 8 7 4 6 2 7v23l-3 10-9 10-6 3-15 2-10-3-5-4-8-11-2-7v-22l4-11 6-7 9-5zm-2 3-8 3-6 5-5 11-1 5v17l4 11 7 8 9 4h13l10-5 6-7 2-5 1-6v-20l-3-9-7-8-6-3-5-1z",
    fill: "#0E5449"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1619,640)",
    d: "m0 0h14l10 5 7 8 3 6 1 17-1 13-5 10-8 6-7 3-12 1-10-4-8-7-5-8-2-7v-15l2-10 4-8 7-6 5-3zm-1 3-10 5-6 9-3 10v13l4 13 6 7 7 4 4 1h12l10-5 6-8 3-10v-16l-3-10-6-8-7-4-3-1z",
    fill: "#0F594D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,180)",
    d: "m0 0 2 1-3 4-10 5-10 8-9 7-10 9-8 8-10 13-11 19-9 21-7 23-2 9-3 3-2 28v18l1 18v11h-1l-2-19v-39l2-18 6-24 8-21 8-16 9-15 13-16 15-15 18-13z",
    fill: "#BB440C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1108,624)",
    d: "m0 0h17l13 4 11 8 8 11 4 11 2 11v11l-5 1-57-1 4-2 7-1h33l15 1-2-13-3-12-6-11-5-6-11-6-11-2-16 1-15 5-8 7-5 8-1 3-4 1 1-6 6-8 7-7 12-6z",
    fill: "#0D5147"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1861,242)",
    d: "m0 0h25l13 4 9 5 10 9 7 8 8 15 5 14v10l-3-3-6-21-7-13-7-9-11-8-12-5-16-3-15 1-17 5-11 7-9 8-7 10-8 17-3 8-2 2 1-10 5-12 5-9 6-8 7-7 10-7 11-5z",
    fill: "#B33D0B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,624)",
    d: "m0 0h23l13 4 9 6 6 9 3 9 1 46 3 7 6 2-1 14-1 1-14 1-8-2-5-5-1-6h2l3 4v2l8 2 12 1-1-8 1-2-5-2-2-5-1-29-2-21-4-11-6-7-12-5-7-1h-13l-20 2 1-3z",
    fill: "#0E5449"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,625)",
    d: "m0 0 21 1v10l-2-1-1-4-15-1v89h17l2 2v-43h1v44h-23l-1-2v-94z",
    fill: "#125D51"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,294)",
    d: "m0 0 1 4-6 13-5 18-2 15v17l4 20 5 14 7 12 11 12 10 8 16 8 15 4 24 1v1l-28 1-12-3-16-10-13-10-8-8-9-14-5-13-5-20v-24l3-17 6-18 5-9z",
    fill: "#B43F0C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,181)",
    d: "m0 0 14 1 24 4 27 8 25 11 13 8 3 3v6l-11 18-4 7h-1l1-7 7-12 5-8-1-3-16-9-15-7-24-8-21-5-24-3-32-1v-1l26-1z",
    fill: "#0E594D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,625)",
    d: "m0 0 20 1v11l-2-3-1-3-14-2 1 84v6h7v1h-9l21 1v1h-23l-1-6v-90z",
    fill: "#186559"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,227)",
    d: "m0 0h6l-2 4-2 1-23 2-20 4-49 14-12 3-7 1h-11l-1-3 18-3 69-18 25-4z",
    fill: "#0E5449"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,641)",
    d: "m0 0 2 1-2 7-3 7-1 7v24l2 9 5 10 8 7 10 5 8 2h19l11-2 7 1-2 2-12 3-17 1-15-3-13-7-8-9-5-10-3-11v-21l3-12z",
    fill: "#0E564B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1484,675)",
    d: "m0 0h18l6 4 1 8-3 8-4 6-7 6-10 4h-12l-7-4-4-5-2-4 1-8 5-8 6-4zm4 3-13 2-6 4-4 6-1 6 3 7 4 3 3 1h11l9-3 8-9 3-9 1-7-1-1z",
    fill: "#0F5A4E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,624)",
    d: "m0 0h23l3 1v2l-7 1h-12l-16 3-14 7-6 9-4 10-2 12v11l2 11 3 8v5h-2l-6-14-1-4v-25l4-12 7-11 8-7 11-5z",
    fill: "#0E554A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1862,307)",
    d: "m0 0h47l24 1 4 2-1 1h-127l-3-2 5-1z",
    fill: "#AD390B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,640)",
    d: "m0 0h15l10 5 6 8v64h-1l-1-52-3-12-4-6-6-3-11-1-9 3-5 5-3 6-1 4-1 60h-22l2-2 17-1 1-64 4-6 9-7z",
    fill: "#0A5045"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,377)",
    d: "m0 0h1l-1 8-6 16-8 12-11 11-10 7-16 8-15 4h-30l-15-5-9-5v-2l6 2 14 5 15 2h11l14-2 16-6 11-6 13-11 10-15 6-15 2-7z",
    fill: "#B43E0C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1112,638)",
    d: "m0 0h12l7 3 8 9 4 10-1 6-3 2-12 1h-32l-2-3 46-1-2-9-6-10-6-3-5-1h-8l-10 4-6 9-4 10-2-1v-7l5-9 9-7z",
    fill: "#0F594D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1721,655)",
    d: "m0 0h1v9h1l2 27 4 11 7 8 8 5 11 4 5 1h16l11-2 4 1-2 2-3 2-6 1h-23l-12-4-10-6-8-9-5-10-3-12v-20z",
    fill: "#0F5A4E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,624)",
    d: "m0 0h17l11 4 8 6 6 9 2 6v57h-1l-1-32-1-17-2-10-5-9-5-5-9-4-6-1h-10l-11 3-9 6-7 6 1-5 7-8 10-5z",
    fill: "#0B4F44"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,587)",
    d: "m0 0h8l10 9 6 8-1 3-7-2-7-4v-2l-6-2-4 2-6 5-8 1 1-5 7-8 5-4z",
    fill: "#257569"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1343,624)",
    d: "m0 0h23l10 3 9 5 8 7 6 10 2 5h-5v-6h-2l-5-7v-2h-2l-3-3-10-5-6-2-11-1h-9l-14 3-12 7-6 5-2 3h-2l2-5 5-6 9-6 10-4z",
    fill: "#0D5247"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,624)",
    d: "m0 0h13l2 1-1 19-1 1-15 1-9 3-5 3-1-3 4-4 13-4 9-1v-6l2-5h-10l-11 4-9 6-4 3 1-5 9-8 8-4z",
    fill: "#0F5A4E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,99)",
    d: "m0 0h1v9l-5 22-3 9-3 4-9-2-21-7-21-4-10-1 3-2-5-1v-1l14 1 23 5 20 7 5 2 7-30 3-10z",
    fill: "#0F554A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,701)",
    d: "m0 0 5 5 4 5 8 5 9 3 5 1h20l11-3 11-6 7-7 2 1-1 4-7 7-10 5-12 3-15 1-13-2-12-5-10-9-3-5z",
    fill: "#0F5A4E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,214)",
    d: "m0 0 1 4-16 32-14 29-11 23-4 1 1-5 8-16 16-33 8-16 8-17z",
    fill: "#B33D0B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1988,423)",
    d: "m0 0 4 1 7 8 11 16 6 12 2 6v11l-3 6-6 7-13 10-14 8h-2l2-4 11-7 12-9 7-7 3-5-1-8-4-13-8-14-8-10z",
    fill: "#B43E0C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,663)",
    d: "m0 0 1 3v17l4 11 7 8 8 3h13l10-5 5-6 2-5 1-6h3l1 2-3 10-9 10-6 3-15 2-10-3-5-4-8-11-2-7 1-13z",
    fill: "#105B4F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1614,624)",
    d: "m0 0h12l12 3 8 6 3 3-1 2-9-6-10-3h-18l-12 4-6 4-3 3h-2l-2 4-4 9h-2l-1 3h-1l1-7 6-10 10-9 13-5z",
    fill: "#0D5247"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,624)",
    d: "m0 0h20l10 4 6 4 7 9 2 4v37h-1l-2-33-4-10-8-7-7-3-5-1-16 1-12 4-5 3h-2l2-4 9-6z",
    fill: "#0B4F45"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,678)",
    d: "m0 0h13l3 3h-16l3 10 5 9 9 5h19l9-5h3v3l-9 5-10 2h-11l-10-5-8-9-2-7v-8z",
    fill: "#105B4F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,650)",
    d: "m0 0 4 3 3 14v13l-3 14-6 12-8 9-7 4h-5v-2l10-6 5-5 6-10 3-9v-26z",
    fill: "#0F5349"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,81)",
    d: "m0 0h73l7 2-1 2h-84l1-3z",
    fill: "#B8420C"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1527,682)",
    d: "m0 0h1l1 16 3 7 6 2-1 14-1 1-14 1-8-2-5-5-1-6h2l3 4v2l8 2 12 1-1-8 1-2-5-2-2-5v-18z",
    fill: "#0F594D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(842,191)",
    d: "m0 0 4 1-1 3-20 7-23 12-7 5h-3l1-6 6-4v2l7-4h2v-2l25-11z",
    fill: "#0C5045"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,623)",
    d: "m0 0 16 2 8 4 5 5 4 5-1 4-9-10-9-4h-19l-11 4-7 4 2-4 4-4 7-4z",
    fill: "#0C5045"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,408)",
    d: "m0 0v3l-9 10-10 8-12 7-10 4-10 2-8 1h-17l-1-2 21-1 17-5 16-8 10-7 10-10z",
    fill: "#B23D0B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,626)",
    d: "m0 0h12l1 4-8 1v8l10 2 2 5-1 30-2 3v-36h-12l-1-1z",
    fill: "#0D574B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1132,170)",
    d: "m0 0 3 3 14 25 8 15 2 6v7l-2 2-2-2v-6l-9-19-10-18-2-3z",
    fill: "#105A4F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1652,706)",
    d: "m0 0 1 3-9 9-10 5-6 1h-18l-10-3-6-3 4-2 10 3 6 1h10l10-2 10-5z",
    fill: "#0F594D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1460,628)",
    d: "m0 0 5 1 4 1-12 5-7 5-2 5 3 2h8l9-2-1 3-5 5-3 1-16-5-1-3 6-10 8-6z",
    fill: "#0E5549"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,377)",
    d: "m0 0h1l-1 8-6 16-8 12-11 11-10 7-6 2 1-3 11-7 9-8 10-15 6-15 2-7z",
    fill: "#B23D0B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,596)",
    d: "m0 0 5 1 3 2v2l5 2 7 3h2l2-2v4l-10-1-3-1-1 2-7-9-2-1-2 4-7 8h-17l1-2 4 1 1-5 3-3 2 3 6-1z",
    fill: "#0E584C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,640)",
    d: "m0 0h15l10 5 6 8v64h-1l-1-52-3-12-4-6-6-3-11-1-7 1-2-2z",
    fill: "#0C5045"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,624)",
    d: "m0 0h17l7 2-1 3-9-1h-10l-11 3-9 6-7 6 1-5 7-8 10-5z",
    fill: "#0C5046"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,624)",
    d: "m0 0h23l3 1v2l-7 1h-12l-16 3-18 9 4-5h2l1-4 11-5z",
    fill: "#0C5247"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,715)",
    d: "m0 0 16 5h19l11-2 7 1-2 2-12 3-17 1-15-3-8-4z",
    fill: "#105B4F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1503,708)",
    d: "m0 0h2l-1 4-8 7-9 4-16 2-12-2-5-5 2-1 11 3h15l11-4 8-6z",
    fill: "#0F5A4E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1140,695)",
    d: "m0 0 20 2 1 2-6 10-7 7-5 1 3-5 6-5 3-5-16-1-2 1 1-4z",
    fill: "#0C564A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1343,624)",
    d: "m0 0h14l-1 3-15 2-11 4-13 9-3 4h-2l2-5 5-6 9-6 10-4z",
    fill: "#0B5045"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1112,677)",
    d: "m0 0h50v4l-61-1 4-2z",
    fill: "#0A4D43"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1619,640)",
    d: "m0 0h14l10 5 7 8 3 6v6l-3 1-3-10-6-8-9-4h-14l-5 1 2-4z",
    fill: "#0F594E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,624)",
    d: "m0 0h13l2 1v3l-14-1v2l-11 4-9 6-4 3 1-5 9-8 8-4z",
    fill: "#0C5045"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,473)",
    d: "m0 0 1 4-3 6-6 7-13 10-14 8h-2l2-4 11-7 12-9 7-7 4-5z",
    fill: "#B84612"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1651,664)",
    d: "m0 0 2 1 1 3-1 21-5 10-8 6-6 2-1-2 3-1 9-9 4-9 1-4z",
    fill: "#0B5045"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1650,588)",
    d: "m0 0h3v48l-2 1-1-3z",
    fill: "#125B4F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,643)",
    d: "m0 0h1v36h2l1 3 2 23 1 4-3 1-3-8-1-12z",
    fill: "#166357"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,181)",
    d: "m0 0 14 1 18 3-1 3 3 1-32-4-32-1v-1l26-1z",
    fill: "#0F554A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1788,627)",
    d: "m0 0 7 1 9 6 7 7 7 14 1 8h-2v-3h-2l-4-11-7-10-8-6-2-1v-2l-6-2z",
    fill: "#0D5247"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,639)",
    d: "m0 0h14l10 4 5 4 3 4-1 5-4-5-7-6-8-2h-11l-9 3 1-4z",
    fill: "#0F5A4E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,131)",
    d: "m0 0m-3 1 3 1-2 90h-1l-1-60z",
    fill: "#AB370B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,624)",
    d: "m0 0h20l-3 3-19 3-9 4-6 2 2-4 9-6z",
    fill: "#0F594D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,247)",
    d: "m0 0h2v2h3v2l-16 4-7 1h-11l-1-3 18-3z",
    fill: "#0F594D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1752,644)",
    d: "m0 0h2v3l-5 5-4 8h-2v21l1 8-3-1-1-5v-20l3-9 7-9z",
    fill: "#0A4E43"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,183)",
    d: "m0 0h7l-2 1-1 3-23 5-10 2 1-4z",
    fill: "#0E5449"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,143)",
    d: "m0 0 4 1 14 24 2 6-1 4-12-21-6-10z",
    fill: "#0D5247"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,99)",
    d: "m0 0h1v9l-5 22-1 4h-3l1-10 4-19z",
    fill: "#0E554A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1614,624)",
    d: "m0 0h12l12 3 8 6 3 3-1 2-9-6-10-3-17-1v-1l5-1z",
    fill: "#105B4F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,239)",
    d: "m0 0 4 1-3 1-1 3-22 6-6-1v-2l24-7z",
    fill: "#0D5247"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,626)",
    d: "m0 0 7 1 9 5 9 8 6 10v5l-2-3v-2h-2l-7-10-9-7-11-5z",
    fill: "#0D5248"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,692)",
    d: "m0 0h1l-1 7-6 10-9 8-4 2h-5v-2l10-6 5-5 6-10 1-3z",
    fill: "#0E5348"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,661)",
    d: "m0 0h1l1 19 2 11 3 8v5h-2l-6-14v-26z",
    fill: "#0B4E43"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,666)",
    d: "m0 0h45v1l-10 1-1 1h-32z",
    fill: "#09493F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1614,641)",
    d: "m0 0m-1 1m-2 1h2v3l-6 4-6 12-1 5h-2v14h-1v-20l4-10 8-7z",
    fill: "#0C5146"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1099,115)",
    d: "m0 0 4 2 14 25-1 2h-3l-13-24z",
    fill: "#0E554A"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1318,640)",
    d: "m0 0v3l-5 10-3 12-2 16h-1v-14l-1-8 4-11 1-2 3-1z",
    fill: "#0D574B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,698)",
    d: "m0 0 2 3v18h7v1h-9l21 1v1h-23v-23z",
    fill: "#115C50"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,643)",
    d: "m0 0 4 1-7 6-7 15-2 13h-1v-15l4-11 6-7z",
    fill: "#0F5449"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,677)",
    d: "m0 0h2v12l-4 11-4 6-3-3 5-10 2-7 1-8z",
    fill: "#0D5247"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,212)",
    d: "m0 0 4 2 2 2v6l-11 18-4 7h-1l1-7 7-12 5-8-1-3-2-2z",
    fill: "#105A4E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,432)",
    d: "m0 0 9 3 15 4 24 1v1l-28 1-12-3-8-5z",
    fill: "#BB440C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1357,624)",
    d: "m0 0h9l10 3 2 3 3 1v2l3 1-2 1-8-4-6-2-11-1-1-2z",
    fill: "#0C5549"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1374,648)",
    d: "m0 0 4 1v2h16l2-3 2 7-20 1-5-6z",
    fill: "#0F5A4E"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,630)",
    d: "m0 0h2l-2 5-7 6-5 8-1 3-4 1 1-6 6-8 7-7z",
    fill: "#0C5146"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,625)",
    d: "m0 0 20 1v11l-2-3-1-3-14-2 1-2-3-1v11h-1z",
    fill: "#0D574B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1378,689)",
    d: "m0 0h24l-1 4-2 3h-2v-4h-19z",
    fill: "#12594E"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028,260)",
    d: "m0 0 6 2 9 8 11-2 4 1-1 2-7 2h-8l-10-7z",
    fill: "#B53F0C"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,663)",
    d: "m0 0 1 3v17l3 9v4l-4-2-3-9 1-13z",
    fill: "#115D51"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,660)",
    d: "m0 0h2l-1 8v10l2 11 4 8v3l-4-2-4-7 1-4-1-6v-16z",
    fill: "#10584D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,654)",
    d: "m0 0 2 4 1 5v21h-1v-7h-2l-2-21h2z",
    fill: "#0F594E"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1102,642)",
    d: "m0 0 1 3-6 8-5 12-2-1v-7l5-9z",
    fill: "#0C5045"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,626)",
    d: "m0 0 4 1-2 1v36h-2l-1-17z",
    fill: "#094D42"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,639)",
    d: "m0 0h9l10 3-1 3-9-2h-11l-6 1-2-2 4-2z",
    fill: "#0F594D"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,693)",
    d: "m0 0 2 3 5 10 8 7 2 1-1 3-5-2-8-9-4-8z",
    fill: "#0E5348"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,644)",
    d: "m0 0h2l1 2-1 30-2 3z",
    fill: "#0C564A"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,705)",
    d: "m0 0 1 3-7 7-8 5-7 1 1-2h2v-2l10-5z",
    fill: "#0D5247"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(963,186)",
    d: "m0 0h7l14 4 3 3h-8l-12-3-4-2z",
    fill: "#0D5247"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,654)",
    d: "m0 0 2 4 2 11v9h-3l-2-13-1-9z",
    fill: "#105B4F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,634)",
    d: "m0 0 5 2 8 11 2 4v5l-3-1-6-12z",
    fill: "#0D5348"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,181)",
    d: "m0 0 14 1v1l-5 1v1l-39-1v-1l26-1z",
    fill: "#186559"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,712)",
    d: "m0 0 3 1v5l13 1v2l3 1h-16l-3-3z",
    fill: "#135E52"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1245,627)",
    d: "m0 0 2 1-1 2 6-1-3 2-9 5-8 6 1-5 9-8z",
    fill: "#0F5A4E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,600)",
    d: "m0 0m-12 1 3 3h6l-1 3-3 3h-13l1-2 4 1 1-5z",
    fill: "#0F5A4E"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(754,643)",
    d: "m0 0 5 1 8 9 2 7h-2l-1 3-3-9-6-7-3-3z",
    fill: "#0F554A"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1484,675)",
    d: "m0 0h18l5 3-2 1-23-1 2-1z",
    fill: "#0B5246"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(811,231)",
    d: "m0 0 2 1-5 5-15 9-3 1 2-4z",
    fill: "#B43F0C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1816,660)",
    d: "m0 0 1 3h2l1 2v16l-3 1-1-12z",
    fill: "#0F564B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,644)",
    d: "m0 0h3l-1 4-5 6-3 5h-3l1-5 4-6z",
    fill: "#0D5146"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,627)",
    d: "m0 0 7 4 6 8-1 4-9-10-9-4 4-1 2 1z",
    fill: "#0D5449"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,625)",
    d: "m0 0 11 2v1l-12 2-8 3-3-1 1-3z",
    fill: "#0D5449"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1108,624)",
    d: "m0 0h17l4 2v1h-24z",
    fill: "#0C4F44"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(912,625)",
    d: "m0 0h4l1 4-11 4-7 4 2-4 4-4z",
    fill: "#0D5348"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,180)",
    d: "m0 0h16l2 2-4 1h-15l-12-1v-1z",
    fill: "#0A5045"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,192)",
    d: "m0 0 1 2-3 3-1 2h-2l-1 3-4 3 1 2-7 4h-2l2-4 14-14z",
    fill: "#0C564A"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(985,191)",
    d: "m0 0 9 2 8 3v4l-10-3-9-3z",
    fill: "#115B4F"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,643)",
    d: "m0 0 4 1-6 5-6 12-1-9 6-7z",
    fill: "#0E5248"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1104,235)",
    d: "m0 0h5l1 3-17 5h-2v-2l3-3z",
    fill: "#0F564B"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1525,655)",
    d: "m0 0h2l1 15v12l-2 2-1-11z",
    fill: "#094B40"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(404,628)",
    d: "m0 0 4 1 9-1-4 2-11 4-9 6-2-1 4-4h2l1-4z",
    fill: "#0C5448"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,650)",
    d: "m0 0 4 3 2 7v4h-2v22h-1l-1-25z",
    fill: "#0D554A"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,625)",
    d: "m0 0 10 3 6 4v3l-15-6-7-1v-1l6-1z",
    fill: "#0D5449"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,625)",
    d: "m0 0h13v3l-13 1-7 1 1-3z",
    fill: "#0C4F44"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1614,624)",
    d: "m0 0h12l7 2-4 2h-17v-1l5-1z",
    fill: "#125C50"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,224)",
    d: "m0 0h2v9l6 10v3l-4-2-4-8-1-7z",
    fill: "#B13C0B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1139,652)",
    d: "m0 0 3 4 1 8-4 4h-11v-1l10-1 1-4-2-7h2z",
    fill: "#0F5A4E"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1767,623)",
    d: "m0 0 20 2v2l-27-1 1-2z",
    fill: "#0D5045"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,596)",
    d: "m0 0 2 2-9 11-5 1-1-2 4-2 7-8z",
    fill: "#0D5549"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(959,126)",
    d: "m0 0h5l-4 2 6 1v1l-15 2h-5l2-4z",
    fill: "#10574C"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1156,703)",
    d: "m0 0 1 3-7 8-4 3-3-1 5-5 6-7z",
    fill: "#0B4F45"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,695)",
    d: "m0 0h3l-1 6-5 7-5 2 2-5z",
    fill: "#0B5045"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1576,665)",
    d: "m0 0h1v22l-2-1-1-7v-10z",
    fill: "#105449"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,643)",
    d: "m0 0 5 1 5 5 3 4v3h-2l-1 4-4-11-6-5z",
    fill: "#0F5449"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1644,650)",
    d: "m0 0h4l5 9v6l-3 1-3-10z",
    fill: "#115C50"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1587,639)",
    d: "m0 0 1 3-5 8-1 3h-2l-1 3h-1l1-7 3-6z",
    fill: "#0B4E44"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1469,625)",
    d: "m0 0h14v1l-11 1v2l-11 1 1-3z",
    fill: "#0B4E43"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(991,624)",
    d: "m0 0 10 1 3 2-1 2-9-1h-15l4-2 8-1z",
    fill: "#0D564A"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,624)",
    d: "m0 0h21l1 2-24 1z",
    fill: "#0A4B41"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(857,187)",
    d: "m0 0 3 1-2 3-10 3h-3l1-4z",
    fill: "#0D5348"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1324,631)",
    d: "m0 0 2 1-2 2v3l-8 6-2 3h-2l2-5 5-6z",
    fill: "#0D5247"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,707)",
    d: "m0 0 1 2-5 6-4 3-4-1 5-6 6-3z",
    fill: "#0E5449"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1651,664)",
    d: "m0 0 2 1 1 3-1 16h-2z",
    fill: "#094C41"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1336,645)",
    d: "m0 0h3l-2 4-4 6-1 3h-3l1-6z",
    fill: "#0C5146"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 197)",
    d: "m0 0 6 1 6 3 2 4-5-1-8-4z",
    fill: "#0D5348"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,130)",
    d: "m0 0 3 3 5 9-1 2h-3l-5-9z",
    fill: "#10574C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1146,696)",
    d: "m0 0 14 1 1 2-3 6-3-4v-2h-5v-2z",
    fill: "#11574C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1608,625)",
    d: "m0 0h14v1l-10 2-1 1h-8l1-3z",
    fill: "#0B4E44"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,678)",
    d: "m0 0h13l3 3h-17z",
    fill: "#156256"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1306,663)",
    d: "m0 0 2 4-1 18-2-2v-17z",
    fill: "#145B50"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,630)",
    d: "m0 0 2 1-2 5-7 7-1-3 6-8z",
    fill: "#10594E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,596)",
    d: "m0 0 1 2-2 3h-2l-2 5-1 3h-4l2-5 6-7z",
    fill: "#0C4F45"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1527,682)",
    d: "m0 0h1l1 20-3-1v-17z",
    fill: "#0C5549"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,666)",
    d: "m0 0 5 1 29 1v1h-32z",
    fill: "#0C564A"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,658)",
    d: "m0 0h1l-1 7-2 13h-1v-15l1-4z",
    fill: "#094C41"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,718)",
    d: "m0 0 3 1v2h-22l2-2z",
    fill: "#09493F"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1132,644)",
    d: "m0 0 4 2 3 4v5l-3-1-4-7z",
    fill: "#0C5045"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,132)",
    d: "m0 0 1 2h2l-1 5-3 4-6-1v-3l5 1z",
    fill: "#105A4E"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,397)",
    d: "m0 0h3l-2 6-4 5-4 2 2-4z",
    fill: "#B7410C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1029,233)",
    d: "m0 0v3l-6 11h-1l1-7 3-6z",
    fill: "#0F584D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1446,710)",
    d: "m0 0 3 1 7 8 1 2-5-2-5-5z",
    fill: "#0D5348"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1818,681)",
    d: "m0 0h1l-1 12-4 2 2-11z",
    fill: "#0D5146"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1650,682)",
    d: "m0 0 1 2h2l-1 8-3 3-1-6z",
    fill: "#0F564A"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(395,633)",
    d: "m0 0h2v2l-5 5-2 5-2 2-2-1 2-5z",
    fill: "#10574C"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1752,644)",
    d: "m0 0h2v3l-7 7-2-1 2-5z",
    fill: "#0D5247"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1132,170)",
    d: "m0 0 3 3 4 7-1 4-4-4z",
    fill: "#0F574B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1707,307)",
    d: "m0 0 1 4-1 11-2 1-1-4 1-9z",
    fill: "#AB370B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,180)",
    d: "m0 0 2 1-3 4-8 4-2-1 4-4z",
    fill: "#B7410C"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,655)",
    d: "m0 0h4l-2 9h-3v-7z",
    fill: "#0F594D"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1377,652)",
    d: "m0 0 18 1v1l-17 2z",
    fill: "#0B4D43"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1460,628)",
    d: "m0 0 5 1 4 1-12 5-5 2 5-5 2-1z",
    fill: "#0C564A"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,626)",
    d: "m0 0 7 1 4 2v2l-7-1-4-2z",
    fill: "#0B5045"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,268)",
    d: "m0 0 4 1-1 2-7 2-4-1v-2z",
    fill: "#B7410C"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1454,671)",
    d: "m0 0h2v2l-5 5-6 4 2-5z",
    fill: "#0D5146"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,129)",
    d: "m0 0h5l-2 3-9 2 1-4z",
    fill: "#0D5247"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1593,632)",
    d: "m0 0m-2 1 2 1-1 4-8 4 2-4z",
    fill: "#0D5449"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(912,625)",
    d: "m0 0h4l1 4-11 3 4-5z",
    fill: "#0E584C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1357,624)",
    d: "m0 0h9v2l-4 2h-5l-1-2z",
    fill: "#0E584C"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,606)",
    d: "m0 0 12 2-4 2h-7z",
    fill: "#0A4C42"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,236)",
    d: "m0 0 5 2 7 5v2l-5-2-7-5z",
    fill: "#B53F0C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1024,209)",
    d: "m0 0 7 1 3 5-5-1-5-3z",
    fill: "#0D5147"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1140,695)",
    d: "m0 0 10 2v1l-9 1-4 3 1-4z",
    fill: "#0D5045"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,643)",
    d: "m0 0 4 1-7 5-5 3 2-4z",
    fill: "#0B5045"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,654)",
    d: "m0 0 2 4v4h-2v6h-1l-1-12h2z",
    fill: "#115C50"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,652)",
    d: "m0 0 1 4-2 4h-3l-1 2 1-6z",
    fill: "#0B5045"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,643)",
    d: "m0 0 4 1-7 5-4 2 2-4z",
    fill: "#0B5045"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,99)",
    d: "m0 0h1v9l-3 4v-9z",
    fill: "#094B40"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,695)",
    d: "m0 0 5 3 2 5-4-1-3-3z",
    fill: "#0B4F44"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,690)",
    d: "m0 0 2 1-1 7-2-1-3 3 3-9z",
    fill: "#0D554A"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1330,628)",
    d: "m0 0h3v2l-4 2-2 3-4-1 5-5z",
    fill: "#0B4E44"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,227)",
    d: "m0 0 2 1-5 5-5 1 2-4z",
    fill: "#B13C0B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(861,186)",
    d: "m0 0h7l-1 3-8 1z",
    fill: "#0F554A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,104)",
    d: "m0 0 3 3 4 7-1 2-2 1-4-11z",
    fill: "#135E52"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1640,700)",
    d: "m0 0 2 1v3l-6 3-3-1 4-4z",
    fill: "#0D5448"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,692)",
    d: "m0 0h1l-1 7-2 2h-2l1-5 1-3z",
    fill: "#0D5146"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1395,648)",
    d: "m0 0 2 3 1 4h-12v-1l5-1 2-2z",
    fill: "#176458"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,639)",
    d: "m0 0h3l3 6v2h-2l-1 2z",
    fill: "#0E5348"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,636)",
    d: "m0 0 3 1-7 8h-2l1-5z",
    fill: "#0B5246"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 627)",
    d: "m0 0 5 1 3 2v3l-6-2-2-1z",
    fill: "#0D5247"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(721,626)",
    d: "m0 0h6l-1 2h-2v2h-7z",
    fill: "#0C5045"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,625)",
    d: "m0 0h9l2 1v2h-8z",
    fill: "#0B4E44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoToome);
export default __webpack_public_path__ + "static/media/logo_toome.b9105d32abd05e8e38bb210064eb1f23.svg";
export { ForwardRef as ReactComponent };